"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDragAndDrop = require("react-drag-and-drop");

var _Button = _interopRequireDefault(require("../Button"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _memoizationHelper = require("../Utilities/memoizationHelper");

var _Option = _interopRequireDefault(require("./Option"));

var _Selection = _interopRequireDefault(require("./Selection"));

var _styles2 = require("./styles");

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _async = _interopRequireDefault(require("react-select/async"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var sortValuesByLabel = function sortValuesByLabel(values) {
  values.sort(function (a, b) {
    var aLabel, bLabel;

    if (isNaN(a.label)) {
      aLabel = a.label.toLowerCase();
    } else {
      aLabel = parseFloat(a.label);
    }

    if (isNaN(b.label)) {
      bLabel = b.label.toLowerCase();
    } else {
      bLabel = parseFloat(b.label);
    }

    if (aLabel < bLabel) {
      return -1;
    }

    if (aLabel > bLabel) {
      return 1;
    }

    return 0;
  });
};

var optionShape = _propTypes.default.arrayOf(_propTypes.default.shape({
  /**
   * The value of the option selected
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),

  /**
   * The text to display in the autocomplete field
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
}));

var Autocomplete = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Autocomplete, _Component);

  var _super = _createSuper(Autocomplete);

  function Autocomplete(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Autocomplete);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      _this.addPortalElement();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.isInDialog !== _this.props.isInDialog) {
        if (_this.props.isInDialog) {
          _this.addPortalElement();
        } else {
          _this.removePortalElement();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentWillUnmount", function () {
      _this.removePortalElement();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addPortalElement", function () {
      if (_this.props.isInDialog && !document.body.contains(_this.portalElement)) document.body.appendChild(_this.portalElement);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removePortalElement", function () {
      if (document.body.contains(_this.portalElement)) document.body.removeChild(_this.portalElement);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "triggerLoadOptions", function (input) {
      var _this$props = _this.props,
          inputThreshold = _this$props.inputThreshold,
          loadOptions = _this$props.loadOptions;

      if (input.length >= inputThreshold) {
        return loadOptions(input);
      } else {
        return Promise.resolve([]);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getValue", function () {
      var _this$props2 = _this.props,
          multiSelect = _this$props2.multiSelect,
          value = _this$props2.value,
          sortSelectedOptions = _this$props2.sortSelectedOptions,
          options = _this$props2.options;

      if (typeof value === "string" || typeof value === "number") {
        return options.find(function (option) {
          return option.name === value;
        });
      }

      var selectedOptions = value;

      if (multiSelect) {
        if (sortSelectedOptions) {
          sortValuesByLabel(selectedOptions);
        }
      }

      return selectedOptions;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "menuCreationText", function (templateString, text) {
      return templateString.replace("{{label}}", text);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDrop", function (object) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          options = _this$props3.options;
      if (onChange) onChange(options.filter(function (option) {
        return option.label === object.label;
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _classNames;

      var _this$props4 = _this.props,
          id = _this$props4.id,
          disabled = _this$props4.disabled,
          error = _this$props4.error,
          errorMessage = _this$props4.errorMessage,
          label = _this$props4.label,
          helperText = _this$props4.helperText,
          loadOptions = _this$props4.loadOptions,
          multiSelect = _this$props4.multiSelect,
          onChange = _this$props4.onChange,
          options = _this$props4.options,
          placeholder = _this$props4.placeholder,
          required = _this$props4.required,
          value = _this$props4.value,
          allowOptionCreation = _this$props4.allowOptionCreation,
          className = _this$props4.className,
          openMenuWhenClicked = _this$props4.openMenuWhenClicked,
          sortSelectedOptions = _this$props4.sortSelectedOptions,
          sortMenuOptions = _this$props4.sortMenuOptions,
          menuCreationText = _this$props4.menuCreationText,
          defaultValue = _this$props4.defaultValue,
          classes = _this$props4.classes,
          isInDialog = _this$props4.isInDialog,
          variant = _this$props4.variant,
          noOptionsMessage = _this$props4.noOptionsMessage,
          inputProps = _this$props4.inputProps,
          styles = _this$props4.styles,
          closeMenuOnSelect = _this$props4.closeMenuOnSelect,
          fullWidth = _this$props4.fullWidth,
          margin = _this$props4.margin,
          isClearable = _this$props4.isClearable,
          enableDroppable = _this$props4.enableDroppable,
          readOnly = _this$props4.readOnly;

      var ClearIndicator = function ClearIndicator(_ref) {
        var innerProps = _ref.innerProps;
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
          className: classes.clearButton,
          type: "icon",
          title: value.length > 1 ? "Clear Values" : "Clear Value"
        }, innerProps), /*#__PURE__*/_react.default.createElement(_Clear.default, {
          fontSize: "small"
        })));
      };

      var SelectComponent = allowOptionCreation ? _creatable.default : loadOptions ? _async.default : _reactSelect.default;
      var renderedNoOptionsMessage = typeof noOptionsMessage !== "undefined" ? noOptionsMessage : allowOptionCreation ? "No options. Start typing to create a new one" : "No options";

      var selectedValues = _this.getValue(); // used for the react-select components


      var selectedOptions = value;
      var menuOptions = options;

      if (sortSelectedOptions && selectedOptions && selectedOptions.length > 1) {
        sortValuesByLabel(selectedOptions);
      }

      if (sortMenuOptions && menuOptions && menuOptions.length > 1) {
        sortValuesByLabel(menuOptions);
      }

      var renderedInputProps = _objectSpread({
        components: {
          ClearIndicator: ClearIndicator
        },
        arrowRenderer: function arrowRenderer(arrowProps) {
          return arrowProps.isOpen ? /*#__PURE__*/_react.default.createElement(_ArrowDropUp.default, null) : /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null);
        },
        clearRenderer: function clearRenderer() {
          return /*#__PURE__*/_react.default.createElement(_Clear.default, null);
        },
        id: id,
        isDisabled: disabled || readOnly,
        isMulti: multiSelect,
        loadOptions: loadOptions ? _this.triggerLoadOptions : undefined,
        options: menuOptions || [],
        optionComponent: _Option.default,
        valueComponent: _Selection.default,
        styles: styles,
        isClearable: isClearable,
        enableDroppable: enableDroppable,
        defaultValue: defaultValue,
        openMenuOnClick: openMenuWhenClicked,
        placeholder: placeholder,
        closeMenuOnSelect: closeMenuOnSelect,
        promptTextCreator: menuCreationText ? function (inputValue) {
          return _this.menuCreationText(menuCreationText, inputValue);
        } : function (inputValue) {
          return inputValue;
        },
        formatCreateLabel: menuCreationText ? function (inputValue) {
          return _this.menuCreationText(menuCreationText, inputValue);
        } : undefined,
        value: selectedValues,
        className: classes.dropdownInputWrapper + " prmbl-dropdownInputWrapper",
        classNamePrefix: _this.props.variant === "compact" ? classes.dropdownInputWrapper + " " + classes.dropdownInputWrapperCompact + " prmbl-autocomplete" : _this.props.variant === "inline" ? classes.dropdownInputWrapper + " " + classes.dropdownInputWrapperInline + " prmbl-autocomplete" : classes.dropdownInputWrapper + " prmbl-autocomplete",
        noOptionsMessage: function noOptionsMessage() {
          return renderedNoOptionsMessage;
        }
      }, inputProps);

      if (isInDialog) {
        renderedInputProps["minMenuHeight"] = 100;
        renderedInputProps["menuPosition"] = "fixed";
        renderedInputProps["menuPortalTarget"] = _this.portalElement;
        _this.portalElement.className = classes.portalElement;

        _this.portalElement.setAttribute("data-testid", "autocomplete-menu-portal");
      }

      var buildDrop = function buildDrop(children) {
        if (enableDroppable) {
          return /*#__PURE__*/_react.default.createElement(_reactDragAndDrop.Droppable, {
            types: ["label"],
            onDrop: _this.handleDrop
          }, children);
        }

        return children;
      };

      return buildDrop( /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        id: id,
        disabled: disabled || readOnly,
        error: error,
        errorMessage: errorMessage,
        margin: margin,
        className: (0, _classnames.default)("prmbl-autocomplete", className, classes.autoCompleteWrapper, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.readOnly, readOnly), _classNames)),
        fullWidth: fullWidth,
        label: label,
        labelProps: (0, _memoizationHelper.memoize)((0, _assertThisInitialized2.default)(_this), "labelProps", function () {
          return {
            shrink: true,
            classes: {
              shrink: classes.autoCompleteLabel
            }
          };
        }, [classes.autoCompleteLabel]),
        helperText: helperText,
        placeholder: placeholder,
        onChange: onChange,
        required: required,
        inputComponent: SelectComponent,
        variant: variant,
        inputProps: (0, _memoizationHelper.memoize)((0, _assertThisInitialized2.default)(_this), "inputProps", function () {
          return renderedInputProps;
        }, [isInDialog, id, disabled, multiSelect, loadOptions, options && options.length, options, defaultValue, placeholder, menuCreationText, selectedValues, selectedValues && selectedValues.length, classes.dropdownInputWrapper, renderedNoOptionsMessage, _Option.default, _Selection.default])
      }));
    });
    _this.portalElement = document.createElement("div");
    return _this;
  }

  return Autocomplete;
}(_react.Component);

(0, _defineProperty2.default)(Autocomplete, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * Initial Value of the selected options in the component. If this is supplied, but not the value you can rely on the component being uncontrolled.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.object, optionShape, _propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * The number of characters to type before results are fetched and displayed using `loadOptions`.
   */
  inputThreshold: _propTypes.default.number,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.string,

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /**
   * Funtion to fetch and return results to display in the options. This should be used if
   * `options` cannot be defined in-line. If both `options` and `loadOptions` are defined, `loadOptions` takes priority.
   *
   * Signature: `function(input: string) => object`
   *
   * input: The text entered into the autocomplete box
   *
   * return: The callback should return a promise with an array of `{ options: [{ value: "", label: "" }]` to display.
   */
  loadOptions: _propTypes.default.func,

  /**
   * If `true` allows multiple options to be selected
   */
  multiSelect: _propTypes.default.bool,

  /**
   * Callback executed when an items is selected or cleared from the autocomplete field.
   *
   * Signature: `function(selected: object) => void`
   *
   * object: The object(s) currently selected, `undefined` if the field has been cleared.
   */
  onChange: _propTypes.default.func,

  /**
   * The options to select from the autocomplete field.
   *
   * If `loadOptions` is defined this field is not required and will be updated by the loadOptions callback.
   * If both `options` and `loadOptions` are defined, `loadOptions` takes priority.
   */
  options: optionShape,

  /**
   * The placeholder text for the component
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, marks the component as being required
   */
  required: _propTypes.default.bool,

  /**
   * Value of the selected options in the component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.object, optionShape, _propTypes.default.string, _propTypes.default.number]),

  /**
   * If true this will use the react-select Creatable component as the inputComponent.
   * which will allow the users to create/add options to the component.
   */
  allowOptionCreation: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * If true, this will sort the options the user has selected by the label. If false, selected values will be appended to the end.
   */
  sortSelectedOptions: _propTypes.default.bool,

  /**
   * True by default. If false, the menu of options will not display when the user does a single click, but will display when the user double clicks.
   * If true, the menu will open when the component is clicked.
   */
  openMenuWhenClicked: _propTypes.default.bool,

  /**
   * If true, the menu of options will be sorted by the label.
   * If false, the menu of options will be shown as passed in.
   */
  sortMenuOptions: _propTypes.default.bool,

  /**
   * A template string of how you would like the tag creation message to display. This string will have {{label}} replaced with what the user is typing.
   *
   * example: 'Create Tag: "{{label}}"'
   */
  menuCreationText: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the Autocomplete will portal to `document.body`.
   */
  isInDialog: _propTypes.default.bool,

  /**
   * How the input appears on page.
   */
  variant: _propTypes.default.oneOf(["standard", "outlined", "filled", "compact", "inline"]),

  /**
   * Makes the input span the entire component's width
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The message displayed when no options are available
   */
  noOptionsMessage: _propTypes.default.string,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Style override object for conditional styling. See https://react-select.com/styles
   */
  styles: _propTypes.default.object,

  /**
   * Whether the menu should close on selection of an item
   */
  closeMenuOnSelect: _propTypes.default.bool,

  /**
   * Whether the value can be cleared
   */
  isClearable: _propTypes.default.bool,

  /**
   * If false, the TextInput will not have a built-in margin
   */
  margin: _propTypes.default.bool,

  /**
   * When true, allows items to be dropped on input.
   */
  enableDroppable: _propTypes.default.bool,

  /**
   * When true, the item will not be editable, but the text will still be selectable
   */
  readOnly: _propTypes.default.bool
});
(0, _defineProperty2.default)(Autocomplete, "defaultProps", {
  inputThreshold: 3,
  className: "",
  isInDialog: false,
  variant: "outlined",
  closeMenuOnSelect: true,
  fullWidth: true,
  enableDroppable: false,
  placeholder: "Select or type to filter..."
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Autocomplete);

exports.default = _default;